
import React from "react";
import "../css/NuestraMision.css";

const NuestraMision = () => {

    return (

        <section
            id="nuestra-mision-component"
            className="esc-mision-section"
        >

            <div className="esc-mision-container">

                <h2 className="esc-mision-title">

                    Nuestra Misión

                </h2>

                <div className="esc-mision-card">

                    <p className="esc-mision-description">

                        Somos una escuela pública, con un trabajo pedagógico que posibilita el desarrollo
                        de habilidades artísticas, deportivas y de pensamiento crítico de las y los estudiantes,
                        desde un enfoque socio-constructivista, asegurando la trayectoria educativa de los y las
                        estudiantes mediante la construcción de ambientes de tolerancia y respeto, para aprender
                        a vivir con un sentido de protección y cuidado personal y social.

                    </p>

                </div>

            </div>

        </section>

    );

};

export default NuestraMision;